<template>
  <dashboard>
    <template v-slot:content>
      <loading v-show="!loading" />
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <b-col lg="12" md="12">
                <b-row class>
                  <b-col lg="4" md="4">
                    <h5 class="mt-2" v-text="Title"></h5>
                  </b-col>
                  <b-col lg="8" md="8">
                    <b-row>
                      <b-col md="3">
                        <div
                          class="total-amount d-flex align-items-center mt-2 float-right"
                        >
                          <span
                            class="h5 mb-0 mr-1"
                            v-text="returnItemQty"
                          ></span>
                          Item(s) for Return
                        </div>
                      </b-col>
                      <b-col md="4" class="p-0">
                        <b-input-group>
                          <b-input-group-text
                            slot="prepend"
                            class="search-icon"
                          >
                            <font-awesome-icon :icon="['fas', 'search']" />
                          </b-input-group-text>
                          <b-form-input
                            placeholder="Search Products"
                            class="search"
                            autocomplete="off"
                            v-model="search"
                            autofocus
                            @keypress.enter="addQty"
                            id="search-return-prod"
                          ></b-form-input>
                        </b-input-group>
                      </b-col>
                      <b-col md="5">
                        <div class="d-flex">
                          <b-button
                            variant="danger"
                            block
                            class="mr-1"
                            @click="cancelReturn"
                            :disabled="$loading"
                            id="cancel-return"
                            >Cancel Return</b-button
                          >
                          <b-button
                            variant="primary"
                            block
                            class="mr-1"
                            @click="sendReturnRequest"
                            :disabled="returnItemQty == 0 || $loading"
                            id="return"
                          >
                            <span v-if="$loading == false">Return</span>
                            <b-spinner
                              small
                              v-if="$loading == true"
                            ></b-spinner>
                          </b-button>

                          <!-- <b-modal hide-footer centered id="return-remarks" title="Return Remarks">
                            <b-form @submit.prevent="sendReturnRequest" id="return-remarks-modal">
                              <b-form-textarea
                                placeholder="Add remark... "
                                id="remark"
                                aria-describedby="remark-validation"
                                cols="30"
                                rows="5"
                                v-model="$v.form.remark.$model"
                                :state="$v.form.remark.$dirty ? !$v.form.remark.$error : null"
                              ></b-form-textarea>

                              <b-form-invalid-feedback
                                id="remark-validation"
                              >Please enter your remark</b-form-invalid-feedback>

                              <div class="text-right">
                                <b-button
                                  class="grey-btn mt-3"
                                  variant="success"
                                  type="submit"
                                  :disabled="$v.form.$invalid || $loading == true"
                                >
                                  <span v-if="$loading == false">Continue</span>
                                  <b-spinner small v-if="$loading == true"></b-spinner>
                                </b-button>
                              </div>
                            </b-form>
                          </b-modal>-->
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section>
        <b-container fluid>
          <div
            class="table-dark-bg box-shadow cart-table-wrapper wow fadeIn mt-2 ret-tb"
          >
            <table class="table cart-table mt-0 table-dark">
              <thead>
                <tr>
                  <th class="text-center">#</th>
                  <th>Product Name</th>
                  <th class="text-center">Qty.</th>
                  <th class="text-center">Sale Price</th>
                  <th class="text-center">Discount</th>
                  <th class="text-center">Net Price</th>
                  <th class="text-center" width="100">Qty. for Return</th>
                  <th class="text-center">Reason for Return</th>
                  <th class="text-center">Select</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(items, index) in returnProducts"
                  :key="items.index"
                  :class="[
                    parseFloat(items.return_qty) == 0 ? 'dis-able' : null,
                  ]"
                >
                  <td class="text-center" v-text="index + 1" />
                  <td>
                    {{ items.product }}
                    <br />
                    <span style="color: #808080;" v-text="items.barcode" />
                  </td>
                  <td class="text-center" v-text="items.quantity" />
                  <td
                    class="text-center"
                    v-text="currencySymbol + formatAmount(items.sale_price)"
                  />
                  <td
                    class="text-center"
                    v-text="currencySymbol + formatAmount(items.discount)"
                  />
                  <td
                    class="text-center"
                    v-text="currencySymbol + formatAmount(items.net_price)"
                  />
                  <td class="text-center">
                    <select
                      v-model="items.selected_qty"
                      v-on:change="checkQTY(items)"
                      class="form-control align-items-center"
                      style="text-align: center; text-align-last: center;"
                      :disabled="parseFloat(items.return_qty) == 0"
                    >
                      <option value="0" class="text-center">0</option>
                      <option
                        v-if="items.weight_flag"
                        v-text="items.return_qty"
                      />

                      <option
                        v-else
                        v-for="qty in parseInt(items.return_qty)"
                        :key="qty"
                        :value="qty"
                        v-text="qty"
                        class="text-center"
                      />
                    </select>
                  </td>
                  <td>
                    <select
                      name
                      class="form-control"
                      v-model="items.return_reason"
                      :disabled="parseInt(items.return_qty) == 0"
                      v-show="items.return_list.length != 0"
                    >
                      <option value="0">Please Select Reason</option>
                      <option
                        v-for="lists in items.return_list"
                        :value="lists.id"
                        v-text="lists.description"
                        :key="lists.index"
                      />
                    </select>
                    <p
                      v-if="items.return_list.length == 0"
                      class="mt-2 mb-2 text-center"
                    >
                      No reason available
                    </p>
                  </td>
                  <td class="text-center">
                    <div class="custom-check">
                      <input
                        class="pull-right"
                        type="checkbox"
                        :id="items.product"
                        v-model="items.status"
                        disabled
                      />
                      <label :for="items.product" />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-container>
      </section>
    </template>
  </dashboard>
</template>

<script>
import Dashboard from "../views/Dashboard";
import Loading from "../components/Loading";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import * as helper from "../helper";

export default {
  name: "return-items",
  mixins: [validationMixin],
  props: ["order_id"],
  value: 0,
  components: {
    Dashboard,
    Loading,
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    returnItemQty() {
      let qty = 0;
      this.state.billing.billing.return_flow.product_list.map((item) => {
        if (item.weight_flag == true) {
          if (item.selected_qty != 0) {
            qty += 1;
          }
        } else {
          qty += parseInt(item.selected_qty);
        }
      });
      return qty;
    },
    returnProducts() {
      let data = this.state.billing.billing.return_flow.product_list;
      if (!this.search) {
        return data;
      }
      const filterValue = this.search.toLowerCase();

      const filter = (event) =>
        event.barcode.includes(filterValue) ||
        event.product.toLowerCase().includes(filterValue);
      this.returnItems = data.filter(filter);
      return data.filter(filter);
    },
  },
  data() {
    return {
      Title: "Select Items for Return",
      selected: null,
      loading: true,
      searchableName: true,
      isContentShow: false,
      dataSet: [],
      returnValue: 1,
      form: {
        remark: "",
      },
      returnItems: [],
      search: "",
    };
  },
  validations: {
    form: {
      remark: {
        required,
        minLength: minLength(3),
      },
    },
  },
  mounted() {
    this.form.remark = this.state.billing.billing.return_flow.remarks;
  },
  watch: {
    search() {
      if (this.search == "") {
        this.returnItems = "";
      }
    },
  },
  methods: {
    checkQTY(value) {
      this.state.billing.billing.return_flow.product_list.map((item) => {
        if (item.barcode == value.barcode && item.unit_mrp == value.unit_mrp) {
          if (value.selected_qty == 0) {
            item.status = false;
          } else {
            item.status = true;
            // selectedReturnItems = [
            //   item.product,
            //   item.quantity,
            //   item.sale_price,
            //   item.discount,
            //   item.net_price
            // ];
          }
        }
        return item;
      });
    },
    async sendReturnRequest() {
      this.$loading = true;
      await helper.checkInvoiceId();
      let returnItem = [];
      this.state.billing.billing.return_flow.product_list.map((item) => {
        if (item.status) {
          returnItem.push({
            item_id: item.barcode,
            qty: item.selected_qty,
            reason_id: item.return_reason,
            batch_id: item.batch_id,
            serial_id: item.serial_id,
            unit_mrp: item.unit_mrp,
          });
        }
      });
      let data = {
        api_token: this.state.sessions.api_token,
        customer_id: this.state.billing.billing.return_flow.customer_info.c_id,
        v_id: this.state.sessions.user.vendor_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        order_id: this.state.billing.billing.return_flow.invoice,
        confirm: 0,
        //terminal_id: this.state.system.settings.terminal_id,
        return_item: JSON.stringify(returnItem),
        url: "/return/request",
      };
      // console.log(data);
      this.state.billing.billing.return_flow.remarks = this.form.remark;
      this.$store
        .dispatch("billing/getReturnRequest", data)
        .then((res) => {
          if (res.data.status == "fail") {
            let alertData = {
              message: res.data.message,
              type: "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          } else {
            this.$router.push("/return-confirmation");
          }
          this.$loading = false;
        })
        .catch(() => {
          // console.log(err.response.data);
          this.$loading = false;
        });
      /* }*/
    },
    cancelReturn() {
      this.$store.commit("billing/clearReturnData");
      this.$router.push("/invoices-history");
    },
    addQty() {
      if (this.returnItems.length == 1) {
        if (this.returnItems[0].return_qty != 0) {
          if (
            this.returnItems[0].selected_qty != this.returnItems[0].return_qty
          ) {
            if (this.returnItems[0].weight_flag == true) {
              this.returnItems[0].selected_qty = parseFloat(
                this.returnItems[0].return_qty
              );
              this.checkQTY(this.returnItems[0]);
            } else {
              this.returnItems[0].selected_qty =
                parseFloat(this.returnItems[0].selected_qty) + 1;
              this.checkQTY(this.returnItems[0]);
            }
          }
        } else {
          return;
        }
      } else {
        return;
      }
      this.search = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-select {
  font-size: 13px;
}
.theme-light .customer-info-data {
  background: $grey-btn-bg;
  height: calc(100vh - 75px);
}

h5 {
  color: $grey-color;
}
.btn-danger {
  text-overflow: none;
}

.dis-able {
  opacity: 0.5;
}
.theme-light textarea:focus {
  background-color: #fff !important;
}
.theme-light .header-elements .total-amount {
  color: #000;
}
.theme-dark .form-control:read-only {
  background-color: #303030 !important;
  color: #c0c0c0;
  border: 1px #c0c0c0 solid !important;
}
</style>
